import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// import {useLocation } from "react-router-dom";
import useNavigate from "hooks/useNavigate";
import { useMediaQuery } from "react-responsive";
import { ButtonIcon } from "@vds-core/button-icons";
import { Button, TextLink } from "@vds/buttons";
import { Grid, Row, Col } from "@vds3/grids";
import { Icon } from "@vds3/icons";
import { Body, Micro } from "@vds3/typography";
// import CheckAvailabilityModal from "../Modals/CheckAvailabilityModal";
import styled from "styled-components";

import {
  StickyContainer,
  FlexContainer,
  LeftContainer,
  TopLine,
  BottomLine,
  TotalsContainer,
  TotalsDiv,
  ShoppingBagContainer,
  AddressContainer,
  BackIconWrapper,
  RowBreak,
  ButtonWrapper,
  ButtonWrapperMobile,
  StyledLineMobile,
  ButtonWrapperCart,
  SkipButtonWrapper
} from "./styles";
import { clear4g5gCart } from "pages/Qualification/ducks/QualificationSlice";
import ShoppingBag from "../SVGIcons/ShoppingBag";
import ShoppingBagEmpty from "../SVGIcons/ShoppingBagEmpty";
import { SelectDevices } from "../../../pages/Mobility/components/PlansNew/Components/PlanNewCompponent";
import ShoppingCartNudgeModal from "../FWA/Modals/ShoppingCartNudgeModal";
import StickyImageContainer from "./StickyImageContainer"
import {setLoadCheckoutWidget,setLoadFWAQualifiedPlans,setLoadMobilityProductDetails,setLoadQualficationSelection,setLoadShoppingCartWidget, setModalFor4GPageOpened, setCallAddOrUpdate } from "app/ducks/GlobalSlice";
import { TextLinkCaret } from "@vds/core";
// import Shopping from '@vds3/icons/shopping';

// const MiniCart = React.lazy(()=>import("pages/MinCart/MiniCart"));

const StyledTextLink = styled(TextLink)`
  :hover {
    color: #000000 !important;
  }
`;

const StickyHeaderVds3 = ({
  pageName,
  headerRef,
  notSticky,
  onContinue,
  onCancel,
  onCartClick,
  enableBackLink,
  backClickHandler,
  hideAddress,
  hideTotals,
  hideContinueButton,
  disabledContinueBtn,
  continueBtnText,
  hideShoppingBagIcon,
  onAddressChange,
  hideBottomLine,
  showSkip,
  zIndex,
  updateAddMoreDevicePopup,
  chatContainer,
  pageHeaderSticky,
  onPlansFirstCartClick,
  isJOBundle,
  hasInternetPackage,
  isfromAgentLinkPage,
  title,
  titleFeature,
  count,
  headetitle,
  pdpstickyHeader,
  pdpButtonEnable,
  showImage = false,
  stickyHeaderConfig,
  pdp = false,
  
  showBagBUSS=false,
  addons = false,
  showContinueClick=false,
  showBackText = false,
  ...props
}) => {
  const { t } = useTranslation([ "app"]);
  const dispatch = useDispatch()
//   const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({
    query: "(max-width: 639px)",
  });
  const [checkAvailabilityModal, setCheckAvailabilityModal] = useState(false);
  const [showCartNudgeModal, setshowCartNudgeModal] = useState(false);
  const [loadMiniCart,setLoadMiniCart] = useState(false)
  const globalData = useSelector((state) => state.ProspectWidgets_GlobalData);
  const BBALQResp = useSelector(
	(state) => state.ProspectWidgets_LQPage?.BBALQResp
);
const sessionId = globalData?.sessionCartData?.apiResponse?.sessionCartMetaData?.identifier ?? ""
  const sessionCartData =
    globalData?.sessionCartData?.apiResponse?.prospectFlowData;
  const fourGData = useSelector((state) => state.Landing4GPage);
  const billing =
    sessionCartData?.discAmountPresentInCart &&
      sessionCartData?.displayTotalAmounts
      ? sessionCartData?.displayTotalAmounts
      : sessionCartData?.totalAmounts;
      const getAddressLine1 = (lqAddressData) =>
        lqAddressData?.addressLine1 ||
        `${lqAddressData?.streetNum || ""} ${lqAddressData?.streetName || ""}`;
    
      const getAddressLine2 = (lqAddressData) =>
        lqAddressData?.addressLine2 ||
        `${lqAddressData?.city || ""}, ${lqAddressData?.state || ""} ${
          lqAddressData?.zipCode || ""
        }`;     
  const itemsInCart =
    sessionCartData?.cart?.packages !== null &&
      sessionCartData?.cart?.packages &&
      Object.values(sessionCartData?.cart?.packages)?.length > 0 ? true : false;
  const cartPage = window.location.pathname.includes('shopping-cart');
  const isPlansFirst = (globalData?.flow == "plans-first" && !globalData?.isPlanFirstFlowCompleted) ? true : false;
//   const addressLine1 = (sessionCartData?.prospectBulkLoopQualAddress &&
//     getAddressLine1(sessionCartData?.prospectBulkLoopQualAddress?.[Object.keys(sessionCartData?.prospectBulkLoopQualAddress)?.[0]])) ||
//   (BBALQResp && getAddressLine1(BBALQResp));

//   const addressLine2 = (sessionCartData?.prospectBulkLoopQualAddress &&
// 		getAddressLine2(sessionCartData?.prospectBulkLoopQualAddress?.[Object.keys(sessionCartData?.prospectBulkLoopQualAddress)?.[0]])) ||
// (BBALQResp && getAddressLine2(BBALQResp));

const isCPC = globalData?.widgetInputParams?.type?.value === "cpc";
const addressLine1 =
		(sessionCartData?.prospectBulkLoopQualAddress &&
			getAddressLine1(sessionCartData?.prospectBulkLoopQualAddress?.[Object.keys(sessionCartData?.prospectBulkLoopQualAddress)?.[0]])) ||
		(BBALQResp && getAddressLine1(BBALQResp));
	const addressLine2 =
	(sessionCartData?.prospectBulkLoopQualAddress &&
		getAddressLine2(sessionCartData?.prospectBulkLoopQualAddress?.[Object.keys(sessionCartData?.prospectBulkLoopQualAddress)?.[0]])) ||
(BBALQResp && getAddressLine2(BBALQResp));
		const isMultiAddress =sessionCartData?.prospectBulkLoopQualAddress && Object.keys(sessionCartData?.prospectBulkLoopQualAddress)?.length >1 ;
  const zipCode = sessionCartData?.cart?.zipCodeFromPlan;
  const hasAddress = !!(addressLine1 && addressLine1.trim());
  const sessionCartId = sessionCartData?.cart?.cartId || globalData?.cartId;
  const monthlyTotal = billing?.dueMonthly;
  const yearlyTotal = billing?.dueYearly;
  const todayTotal = billing?.dueToday;
  const hideIcon = props?.fromFwa ? (!disabledContinueBtn && !globalData?.isWirelessToFwaFlow) : false;
  const totalsEnabled =
    t("app.common.page-stepper.enable-totals", {
      ns: "app", returnObjects: true
    });
  const showTotals = !hideTotals && totalsEnabled;
  const isShoppingBagChange = t("enableShoppingBagChange", { ns: "app" });
  const newShoppingIcon = t("newShoppingBagIcon", { ns: "app" })
  const prevShoppingIcon = t("prevShoppingBagIcon", { ns: "app" })
  const newY_Index = t("newYindex_redIndicator", { ns: "app" })
  const prevY_Index = t("prevYindex_redIndicator", { ns: "app" })

//   const handleCheckAvailability = () => {
//     setCheckAvailabilityModal(true)
//   }
 
//   useEffect(() => {
//     if (fourGData?.checkAvailabilityRedirection) {
//       setCheckAvailabilityModal(false)
//     }
//   }, [fourGData?.checkAvailabilityRedirection]);

  return (
    <>
      <StickyContainer position={!!notSticky} ref={headerRef} zIndex={zIndex} id="sticky-header-vds-3" style={{ display: (pageName == "vbc" && isMobile) ? "none" : "block" }} pdp={pdp}>
        {/* {checkAvailabilityModal &&
          <CheckAvailabilityModal
            onOpenedChange={setCheckAvailabilityModal}
            opened={checkAvailabilityModal}
          />} */}
		  {/* commenting minicart */}
          {/* {String(window.mbtGlobal.aemBaseUrl).toUpperCase().includes('QA') ? 
      <MiniCart openModal={loadMiniCart}/>:<></>} */}
        {/* <TopLine surface="dark" /> */}
        <Grid colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
          <Row>
            <ColNoPad>
              <FlexContainer hasAddress={hasAddress}>
                <LeftContainer pdp={props.pdp} cartPage={cartPage} isMobile={isMobile}>
                  <span style={{ margin: "auto", display: "flex" }}>
                    {!!enableBackLink && (
                      <BackIconWrapper onClick={() => backClickHandler()}>
                        {isfromAgentLinkPage ? <Icon
                          ariaHidden={true}
                          name="home"
                          color="#000000"
                          surface="light"
                          size="medium"
                        />
                          :
                          // <Icon
                          //   ariaHidden={true}
                          //   name="left-caret"
                          //   color="#000000"
                          //   surface="light"
                          //   size="medium"
                          // />
                             <TextLinkCaret
                                      surface="light"
                                      iconPosition="left"
                                      style={{ paddingLeft: "0px" }}
                                      size="medium"
                                    
                                    >{(isMultiAddress|| showBackText)?"Back":""}</TextLinkCaret>}
                        {title}
                        {titleFeature}
                        {headetitle}
                      </BackIconWrapper>
                    )}
                    {showImage && !isPlansFirst && <StickyImageContainer imageSet={stickyHeaderConfig?.imageSet} selectContent={stickyHeaderConfig?.selectContent} description={stickyHeaderConfig?.description} byod={stickyHeaderConfig?.byod}></StickyImageContainer>}
                    {props?.fromFwa && sessionCartData?.showLinkForMixedCart && fourGData?.showCheckAvailabiltyLink && <div style={{ width: "15rem" }}>
                      <Body size="small" color="#000000">
                        {t("app.common.page-stepper.checkAvailabilityText", { ns: "app", })}
                        <StyledTextLink
                          surface="dark"
                          color="#000000"
                          size="small"
                          type="inline"
                          onClick={handleCheckAvailability}
                        >
                          {"Check availability"}
                        </StyledTextLink>
                      </Body>
                    </div>}
                    {!hideAddress && !isMultiAddress&& !fourGData?.showCheckAvailabiltyLink && hasAddress && (
                      <AddressContainer>
                        <div>
                          {addressLine1 && (
                            <div>
                              <Body size="small" color="#000000">
                                {addressLine1}
                              </Body>
                            </div>
                          )}
                          {addressLine2 && addressLine2.trim() !== "," && (
                            <div>
                              <Body size="small" color="#000000">
                                {addressLine2}&nbsp;
                                {!isCPC && (
                                    <TextLink
                                      surface="dark"
                                      color="#000000"
                                      size="small"
                                      type="inline"
                                      onClick={onAddressChange}
                                    >
                                      {"Change"}
                                    </TextLink>
                                  )}
                              </Body>
                            </div>
                          )}
                        </div>
                      </AddressContainer>
                    )}
                  </span>
                </LeftContainer>
                {!!isMobile && !hideShoppingBagIcon && hasAddress && (
                  <>
                    {/* {!hideShoppingBagIcon && hasAddress && ( */}
                    <ShoppingBagContainer onClick>
                      <Icon
                        name={isShoppingBagChange == "Y" ? newShoppingIcon : prevShoppingIcon}
                        color="#FFFFFF"
                        surface="dark"
                        size="large"
                      />
                    </ShoppingBagContainer>
                    {/* )} */}
                    {/* {hasAddress && !hideAddress && <RowBreak />} */}
                    <TotalsContainer
                      hasAddress={hasAddress && !hideAddress}
                      pdp={props.pdp}
                      isMobile={isMobile}
                    >
                      {/* {hasAddress && (
                        <BackIconWrapper>
                          <Icon
                            name="left-caret"
                            color="#FFFFFF"
                            size="medium"
                          />
                        </BackIconWrapper>
                      )} */}
                      {showTotals && (
                        <Totals
                          dueMonthly={monthlyTotal}
                          dueToday={todayTotal}
                          dueYearly={yearlyTotal}
                        />
                      )}
                    </TotalsContainer>
                  </>
                )}
                {showTotals && (
                  <Totals dueMonthly={monthlyTotal} dueToday={todayTotal} dueYearly={yearlyTotal}/>
                )}
                {(!hideContinueButton && !cartPage && !isPlansFirst && !showContinueClick) && (
                  <ButtonWrapper
                    use="primary"
                    onClick={() => onContinue()}
                    disabled={disabledContinueBtn}
                    size="small"
                    style={{ height: "32px" }}
                    data-track={continueBtnText
                      ? continueBtnText
                      : t("app.common.page-stepper.continue-btn", {
                        ns: "app",
                      })}
                  >
                    {continueBtnText
                      ? continueBtnText
                      : t("app.common.page-stepper.continue-btn", {
                        ns: "app",
                      })}
                  </ButtonWrapper>
                )}
                {(showContinueClick || (!hideContinueButton && cartPage )) && (
                  <ButtonWrapperCart
                    use="primary"
                    onClick={() => onContinue()}
                    disabled={showContinueClick ? false : disabledContinueBtn}
                    size="small"
                    style={{ height: "32px" }}
                    data-track={continueBtnText
                      ? continueBtnText
                      : t("app.common.page-stepper.continue-btn", {
                        ns: "app",
                      })}
                  >
                    {continueBtnText
                      ? continueBtnText
                      : t("app.common.page-stepper.continue-btn", {
                        ns: "app",
                      })}
                  </ButtonWrapperCart>
                )}
               
                {showSkip && !isMobile &&
                  <div style={{ marginLeft: "-5px" }}>
                    <SkipButtonWrapper
                      use="secondary"
                      onClick={() => onCartClick()}
                      disabled={false}
                      size="small"
                      data-track="Skip"
                    >
                      {"Skip"}
                    </SkipButtonWrapper></div>}
                    <div style={{ width: "0rem"}}>
                {globalData?.isGNAVHeaderInView && (!hideShoppingBagIcon && !hideIcon) &&
                  (hasAddress || (pdp || props.pdp || addons)) && (
                   
                      <ButtonIcon
                        kind="ghost"
                        size="large"
                        surface="light"
                        renderIcon={(props) => (
                          <Icon
                            name={isShoppingBagChange == "Y" ? newShoppingIcon : prevShoppingIcon}
                            {...props} />
                        )}
                        hideBorder={true}
                        disabled={false}
                        // style={{ width: "2px" }}
                        showBadgeIndicator={itemsInCart}
                        badgeIndicator={{
                          kind: "simple",
                          dotSize: 0,
                          offset: {
                            x: 3,
                            y: isShoppingBagChange == "Y" ? newY_Index : prevY_Index,
                          },
                          size: 10
                        }}
                        onClick={() => {
                          if (props?.fromLandingPage4g || props?.isFromLanding5g) {
                            dispatch(setCallAddOrUpdate(false));
                            if (isJOBundle && globalData?.isJoBundleEnabled && !hasInternetPackage && !globalData.modalFor4GPageOpened) {
                              setshowCartNudgeModal(true)
                              dispatch(setModalFor4GPageOpened(true))
                              // onContinue("","",true)
                            } else {
                              props?.setIsShoppingIconClicked(true);
                              onContinue("", "", true)
                            }

                          } else if (props.fromFeature) onCartClick()
                          else if (props.fromPlansFirstFlow) onPlansFirstCartClick()
                          else navigate("/shop/shopping-cart")
                        }}
                      />                 
                  )} </div>
				  {/* shoppingicon */}
                  {/* {String(window.mbtGlobal.aemBaseUrl).toUpperCase().includes('QA') ? 
                  <div style={{cursor:'pointer'}} onClick={()=>{
                    setLoadMiniCart(false)
                    setTimeout(()=>{setLoadMiniCart(true)})
                  }}>
                  <Shopping color="black" size={"XLarge"}/> 
                  </div>: <></>} */}
              </FlexContainer>
            </ColNoPad>
          </Row>

        </Grid>
        {!hideBottomLine && <BottomLine type="secondary" surface="light" />}
	
        {pageHeaderSticky &&
          <Grid colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
            <TopSection>
              <GridHOC>
                {chatContainer}
                <SelectDevices updateAddMoreDevicePopup={updateAddMoreDevicePopup} pageHeaderSticky={pageHeaderSticky} />
              </GridHOC>
            </TopSection>
          </Grid>
        }
      </StickyContainer>
      {(!hideContinueButton && !cartPage && !props.pdp) && (
        <>
          <StyledLineMobile type="secondary" />
          <ButtonWrapperMobile>
            <Button
              use="primary"
              onClick={() => onContinue()}
              disabled={disabledContinueBtn}
              size="small"
              style={pdpButtonEnable ? { height: "44px",width:"350px",align:"center"} : { height: "44px", width: '350px' }}
            >
              {continueBtnText
                ? continueBtnText
                : t("app.common.page-stepper.continue-btn", {
                  ns: "app",
                })}
            </Button>
          </ButtonWrapperMobile>
        </>
      )}
      {showCartNudgeModal && (<ShoppingCartNudgeModal opened={showCartNudgeModal} modalFor4GPageOpened={globalData.modalFor4GPageOpened}
      loadShoppingCart = {()=>navigate("/shop/shopping-cart")}
      onOpenedChange={setshowCartNudgeModal} onContinue={onContinue} url={""} />)}
    </>
  )
};

const Totals = ({ dueMonthly, dueToday,dueYearly, ...props }) => {
  return (
    <TotalsDiv style={{gap:"1rem" }}>
      <div>
        <div style={{ width: "max-content"}}>
          <Micro color="#000000">
            Due today
          </Micro>
        </div>
        <Body bold size="large" color="#000000">
          {`$${(!dueToday ? 0 : dueToday).toFixed(2)}*`}
        </Body>
      </div>
      {((dueMonthly&&dueMonthly>0) || !(dueYearly&&dueYearly>0)) ? 
      <div>
        <div style={{ width: "max-content", marginRight: "8px" }}>
          <Micro color="#000000">
            Due monthly
          </Micro>
        </div>
        <Body bold size="large" color="#000000">
          {`$${(!dueMonthly ? 0 : dueMonthly).toFixed(2)}*`}
        </Body>
      </div>
      :<></>}
      {(dueYearly&&dueYearly>0) ? 
      <div>
        <div style={{ width: "max-content", marginRight: "8px" }}>
          <Micro color="#000000">
            Due yearly
          </Micro>
        </div>
        <Body bold size="large" color="#000000">
          {`$${(!dueYearly ? 0 : dueYearly).toFixed(2)}*`}
        </Body>
      </div>
      :<></>}
    </TotalsDiv>
  );
};

const TopSection = styled.div`
  padding: 0 1rem 1rem 0.25rem;
`;
export const RowNoPad = styled(Row)`
  padding: 0 !important;
`;
export const ColNoPad = styled(Col)`
  padding: 0 !important;
`;

const GridHOC = ({ children }) => {
  return (
    <Grid
      colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
      colGutter={false}
    >
      <RowNoPad>
        <ColNoPad colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
          {children}
        </ColNoPad></RowNoPad></Grid>
  )
}

export default StickyHeaderVds3;
